var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwiperightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 92"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 19.5,
    cy: 19.5,
    r: 17.5,
    fill: "#0D99FF",
    stroke: "#0D99FF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.999 20.2089C25.991 19.8588 25.857 19.5242 25.6229 19.2699L17.3704 10.4318C17.1165 10.1621 16.7689 10.0069 16.4039 10.0002C16.0389 9.99355 15.6861 10.1359 15.423 10.3962C15.16 10.6565 15.0079 11.0133 15.0003 11.3886C14.9928 11.7639 15.1302 12.127 15.3826 12.3983L22.7216 20.2531L15.3826 28.108C15.1302 28.3792 14.9928 28.7423 15.0003 29.1176C15.0079 29.4929 15.16 29.8498 15.423 30.11C15.6861 30.3703 16.0389 30.5127 16.4039 30.506C16.7689 30.4993 17.1165 30.3441 17.3704 30.0744L25.6229 21.2363C25.749 21.0995 25.8473 20.9381 25.9119 20.7617C25.9764 20.5852 26.0061 20.3973 25.999 20.2089Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperightIcon);
export default __webpack_public_path__ + "static/media/swiperightIcon.5b3d2673244ac8894d985f39bfc925cb.svg";
export { ForwardRef as ReactComponent };